import { accordionAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const outline = definePartsStyle({
  container: {
    border: '1px solid',
    borderColor: 'gray.100 !important',
    borderRadius: 12,
  },
  panel: {
    borderTop: '1px solid',
    borderColor: 'gray.100 !important',
  },
  icon: {
    color: 'gray.500',
  },
});

export const accordionTheme = defineMultiStyleConfig({
  variants: { outline },
});
